(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["silensia-areas-of-expertise"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';

  var mobileQuery = window.matchMedia(
    '(hover: none) and (pointer: coarse)'
  );

  var rafId = null;

  function initExpertiseScroll(root) {
    if (!root || root.dataset.expertiseScrollReady === 'true') {
      return;
    }

    var cards = Array.prototype.slice.call(
      root.querySelectorAll('[data-expertise-card]')
    );

    if (!cards.length) {
      return;
    }

    root.dataset.expertiseScrollReady = 'true';

    function clearActiveCards() {
      cards.forEach(function (card) {
        card.classList.remove('is-mobile-active');
      });
    }

    function updateActiveCard() {
      rafId = null;

      /*
       * Desktop/fine pointer keeps using the existing :hover behaviour.
       */
      if (!mobileQuery.matches) {
        root.classList.remove('is-scroll-enhanced');
        clearActiveCards();
        return;
      }

      root.classList.add('is-scroll-enhanced');

      /*
       * Activation line.
       *
       * 0.55 = 55% down the viewport.
       *
       * Slightly below the exact centre feels more natural because the
       * visitor sees the card approaching before its content opens.
       */
      var activationY = window.innerHeight * 0.10;

      var activeCard = null;
      var closestDistance = Infinity;

      cards.forEach(function (card) {
        var rect = card.getBoundingClientRect();

        /*
         * Ignore cards completely outside the viewport.
         */
        if (
          rect.bottom <= 0 ||
          rect.top >= window.innerHeight
        ) {
          return;
        }

        var cardCenter =
          rect.top + rect.height / 2;

        var distance =
          Math.abs(cardCenter - activationY);

        if (distance < closestDistance) {
          closestDistance = distance;
          activeCard = card;
        }
      });

      cards.forEach(function (card) {
        card.classList.toggle(
          'is-mobile-active',
          card === activeCard
        );
      });
    }

    function requestUpdate() {
      if (rafId !== null) {
        return;
      }

      rafId = window.requestAnimationFrame(
        updateActiveCard
      );
    }

    window.addEventListener(
      'scroll',
      requestUpdate,
      { passive: true }
    );

    window.addEventListener(
      'resize',
      requestUpdate
    );

    if (typeof mobileQuery.addEventListener === 'function') {
      mobileQuery.addEventListener(
        'change',
        requestUpdate
      );
    }

    updateActiveCard();
  }

  function init() {
    var sections =
      document.querySelectorAll(
        '.silensia-expertise'
      );

    sections.forEach(function (section) {
      initExpertiseScroll(section);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      init
    );
  } else {
    init();
  }

  /*
   * Shopify Theme Editor support.
   */
  document.addEventListener(
    'shopify:section:load',
    function (event) {
      var section =
        event.target &&
        event.target.matches &&
        event.target.matches('.silensia-expertise')
          ? event.target
          : event.target.querySelector
            ? event.target.querySelector('.silensia-expertise')
            : null;

      if (section) {
        initExpertiseScroll(section);
      }
    }
  );
})();

/* ------------------------------------------------------------------
   Conditions sheets (11 September 2026). Stacked layout: the button
   inside each card opens its conditions in a bottom sheet.

   Adds .is-sheet-enhanced to the section once wired, and only where
   <dialog>.showModal() exists. The stylesheet hides the accordions and
   shows the buttons only under that class, so without JavaScript -- or
   without <dialog> -- the accordion stays and the lists stay reachable.
   ------------------------------------------------------------------ */
(function () {
  'use strict';

  function initSheets(root) {
    if (!root || root.dataset.expertiseSheetsReady === 'true') return;
    var sheets = root.querySelectorAll('dialog.silensia-expertise__sheet');
    if (!sheets.length || typeof sheets[0].showModal !== 'function') return;
    root.dataset.expertiseSheetsReady = 'true';

    var opener = null;

    root.addEventListener('click', function (event) {
      var trigger = event.target.closest('[data-expertise-sheet-open]');
      if (trigger) {
        var sheet = document.getElementById(trigger.getAttribute('data-expertise-sheet-open'));
        if (!sheet) return;
        opener = trigger;
        sheet.showModal();
        var close = sheet.querySelector('[data-expertise-sheet-close]');
        if (close) close.focus();
        return;
      }

      if (event.target.closest('[data-expertise-sheet-close]')) {
        var openSheet = event.target.closest('dialog');
        if (openSheet) openSheet.close();
        return;
      }

      // A tap on the backdrop reports the dialog itself as its target. The
      // panel fills the sheet edge to edge, so nothing inside it ever does.
      if (event.target.classList && event.target.classList.contains('silensia-expertise__sheet')) {
        event.target.close();
      }
    });

    Array.prototype.forEach.call(sheets, function (sheet) {
      sheet.addEventListener('close', function () {
        if (opener && document.contains(opener)) opener.focus();
        opener = null;
      });
    });

    root.classList.add('is-sheet-enhanced');
  }

  function init() {
    Array.prototype.forEach.call(document.querySelectorAll('.silensia-expertise'), initSheets);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var t = event.target;
    if (!t || !t.querySelectorAll) return;
    if (t.matches && t.matches('.silensia-expertise')) initSheets(t);
    Array.prototype.forEach.call(t.querySelectorAll('.silensia-expertise'), initSheets);
  });
})();

  } catch(e) { console.error(e); }
})();
})();
